export default __webpack_public_path__ + "static/media/my.c006aa99.svg";